import { Selector } from '@ngrx/store';
import { FrontendEnvironment } from './environment.model';
import { AppState } from '../../../../apps/int-client/src/app/shared/store/app-state.model';

export const frontendEnvironment: Selector<AppState, FrontendEnvironment | null> = getEnvironment();

export function getEnvironment(): Selector<AppState, FrontendEnvironment | null> {
	return (state: AppState) => <FrontendEnvironment>state.environment;
}
